import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Blaze = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  if (color === 'currentColor') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
        <path
          d="M10.0433 12.8279C10.0615 12.8279 10.0814 12.8279 10.103 12.828C10.6326 12.8297 12.1502 12.8347 13.3003 11.9571C14.1337 11.321 14.6381 10.3231 14.6381 9.22655C14.6381 8.45894 14.5394 7.94354 14.117 7.34041C14.117 7.34041 15 6.56183 15 5.23093C15 3.72168 14.256 2.50779 12.5209 2.1157C12.0108 2.00043 10.7668 2 10.7668 2L6.64997 2.00087L2.65522 6.42553L1.00001 12.828L4.19362 12.8268L10.0433 12.8279Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.19362 12.8268L10.0433 12.8279C10.0615 12.8279 10.0814 12.8279 10.103 12.828C10.6326 12.8297 12.1502 12.8347 13.3003 11.9571C14.1337 11.321 14.6381 10.3231 14.6381 9.22655C14.6381 8.45894 14.5394 7.94354 14.117 7.34041C14.117 7.34041 15 6.56183 15 5.23093C15 3.72168 14.256 2.50779 12.5209 2.1157C12.0108 2.00043 10.7668 2 10.7668 2L6.64997 2.00087L2.65522 6.42553L1.00001 12.828L4.19362 12.8268Z"
          fill="black"
        />
        <path
          d="M5.08984 12.0094L7.19529 2.71924H11.3798C11.7088 2.71924 12.4194 2.77187 12.8668 2.98241C13.7353 3.39034 14.038 4.21934 14.038 4.91676C14.038 5.39048 13.9064 5.8642 13.6169 6.2458C13.1695 6.85111 12.5905 6.99586 12.1299 7.11429C12.8537 7.44326 13.709 7.82486 13.709 9.20654C13.709 9.96975 13.3537 10.6935 12.801 11.1935C11.9852 11.9304 10.8535 12.0094 10.2613 12.0094H5.08984ZM9.07702 4.40357L8.61646 6.37739H10.3403C10.814 6.35107 11.7746 6.3116 11.7746 5.24573C11.7746 4.4562 11.1035 4.41673 10.7482 4.40357H9.07702ZM8.23485 8.06172L7.7348 10.2987H9.74813C10.2482 10.2856 10.7219 10.2724 11.064 9.81184C11.2483 9.56183 11.3009 9.25917 11.3009 9.02231C11.3009 8.86441 11.2746 8.71966 11.2219 8.58807C10.9851 8.1012 10.5377 8.08804 10.1692 8.06172H8.23485Z"
          fill="white"
        />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M12.5542 16.0349C12.5769 16.0349 12.6018 16.0349 12.6288 16.035C13.2907 16.0372 15.1878 16.0434 16.6253 14.9463C17.6671 14.1513 18.2977 12.9039 18.2977 11.5332C18.2977 10.5737 18.1743 9.92942 17.6463 9.17552C17.6463 9.17552 18.75 8.20229 18.75 6.53867C18.75 4.6521 17.82 3.13474 15.6511 2.64462C15.0135 2.50054 13.4585 2.5 13.4585 2.5L8.31247 2.50109L3.31903 8.03192L1.25002 16.035L5.24203 16.0335L12.5542 16.0349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24203 16.0335L12.5542 16.0349C12.5769 16.0349 12.6018 16.0349 12.6288 16.035C13.2907 16.0372 15.1878 16.0434 16.6253 14.9463C17.6671 14.1513 18.2977 12.9039 18.2977 11.5332C18.2977 10.5737 18.1743 9.92942 17.6463 9.17552C17.6463 9.17552 18.75 8.20229 18.75 6.53867C18.75 4.6521 17.82 3.13474 15.6511 2.64462C15.0135 2.50054 13.4585 2.5 13.4585 2.5L8.31247 2.50109L3.31903 8.03192L1.25002 16.035L5.24203 16.0335Z"
        fill="white"
      />
      <path
        d="M6.36232 15.0114L8.99413 3.39879H14.2248C14.6361 3.39879 15.5243 3.46458 16.0835 3.72776C17.1692 4.23766 17.5475 5.27392 17.5475 6.14569C17.5475 6.73784 17.383 7.32999 17.0211 7.80699C16.4619 8.56363 15.7381 8.74456 15.1624 8.8926C16.0671 9.30381 17.1363 9.78082 17.1363 11.5079C17.1363 12.4619 16.6921 13.3666 16.0013 13.9916C14.9815 14.9128 13.5669 15.0114 12.8267 15.0114H6.36232ZM11.3463 5.5042L10.7706 7.97148H12.9254C13.5175 7.93858 14.7183 7.88924 14.7183 6.55691C14.7183 5.56999 13.8794 5.52065 13.4353 5.5042H11.3463ZM10.2936 10.0769L9.66853 12.8731H12.1852C12.8102 12.8567 13.4024 12.8402 13.8301 12.2645C14.0603 11.952 14.1261 11.5737 14.1261 11.2776C14.1261 11.0803 14.0932 10.8993 14.0274 10.7348C13.7314 10.1262 13.1721 10.1098 12.7115 10.0769H10.2936Z"
        fill={color}
      />
    </svg>
  )
})

export default Blaze
